import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

/**
 * @param {Object} props
 * @returns
 */
function Summary({ overview, loading }) {
  const items = [
    {
      title: 'ZK',
      info: (
        <>
          <CountUp end={overview.activeZKNodeCount} duration={0.4} />/
          <CountUp end={overview.totalZKNodeCount} duration={0.4} />
        </>
      ),
      icon: 'other2',
      unit: overview.zkVersion,
    },
    {
      title: 'ZNode',
      icon: 'other3',
      info: <CountUp end={overview.zkDataNodeCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Watch',
      icon: 'other4',
      info: <CountUp end={overview.watchCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Leader',
      icon: 'other1',
      info: overview.leaderIp || '-',
    },
    {
      title: 'Follower',
      icon: 'other5',
      info: <CountUp end={overview.followerCount} duration={0.4} />,
    },
    {
      title: 'Observer',
      icon: 'other2',
      info: <CountUp end={overview.observerCount} duration={0.4} />,
    },
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect((state) => ({
  overview: state.kopZookeeper.overview,
  loading: state.kopZookeeper.loading,
}))(Summary);
